/*
 * call me puppy — weiches Auf-/Zuklappen für <details data-cmp-smooth> (nach ivyclip):
 * Öffnen: Höhe wächst 250 ms (ease), Inhalt blendet in den letzten 150 ms ein.
 * Schließen: Inhalt blendet 150 ms aus, gleichzeitig fährt die Höhe 250 ms zu.
 * Schwebt der Inhalt als Popup (position absolute/fixed, z. B. Horizon-Filter auf dem Desktop),
 * wird nur ein- bzw. ausgeblendet — die Höhe des <details> ändert sich dort ja nicht.
 * Ein einziger delegierter Klick-Listener (auch für nachgeladene Sections), keine Library,
 * nativ per Web Animations API. Bei „Bewegung reduzieren“ klappt es wie gewohnt ohne Animation.
 */
(() => {
  if (!('animate' in Element.prototype)) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const HEIGHT = { duration: 250, easing: 'ease' };
  const FADE = { duration: 150, easing: 'ease' };

  document.addEventListener('click', (event) => {
    // Horizon sperrt manche Akkordeons bewusst (z. B. nur Desktop) per preventDefault
    if (event.defaultPrevented) return;
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.hasAttribute('data-cmp-smooth')) return;
    if (reducedMotion.matches || summary.isContentEditable) return;
    event.preventDefault();
    toggle(details, summary);
  });

  function toggle(details, summary) {
    // Klick während einer laufenden Animation dreht die Richtung um
    const opening = details.dataset.cmpState ? details.dataset.cmpState === 'closing' : !details.open;
    const startHeight = details.offsetHeight; // vor dem Abbrechen messen, sonst springt die Höhe
    details._cmpAnimations?.forEach((animation) => animation.cancel());

    details.open = true;
    const content = Array.from(details.children).filter((el) => el !== summary);
    const floating = content.length > 0 && content.every((el) => /^(absolute|fixed)$/.test(getComputedStyle(el).position));
    details.dataset.cmpState = opening ? 'opening' : 'closing';

    const fade = (delay) =>
      content.map((el) =>
        opening
          ? el.animate({ opacity: [0, 1], transform: ['translateY(-4px)', 'translateY(0)'] }, { ...FADE, delay, fill: 'backwards' })
          : el.animate({ opacity: [1, 0] }, { ...FADE, fill: 'forwards' })
      );

    let animations;
    if (floating) {
      animations = fade(0);
    } else {
      const openHeight = details.offsetHeight;
      details.open = false;
      const closedHeight = details.offsetHeight;
      details.open = true;
      details.style.overflow = 'hidden';
      animations = [
        details.animate({ height: [`${startHeight}px`, `${opening ? openHeight : closedHeight}px`] }, HEIGHT),
        ...fade(100),
      ];
    }
    details._cmpAnimations = animations;
    if (!animations.length) return finish(details, opening, animations);

    // Die längste Animation bestimmt das Ende
    animations[0].finished
      .then(() => finish(details, opening, animations))
      .catch(() => {}); // abgebrochen durch erneuten Klick — die neue Animation übernimmt
  }

  function finish(details, opening, animations) {
    details.open = opening;
    animations.forEach((animation) => animation.cancel());
    details.style.overflow = '';
    delete details.dataset.cmpState;
    details._cmpAnimations = null;
  }
})();
